export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    styleManager.addType(window.PMW.emails.styles.ID_MOD_LIST, {
        /**
         *
         * @param {object} props
         * @param {grapesjs.Component} props.component
         * @param {string} props.type
         * @param {string} props.class
         * @param {string} props.list.action
         * @param {array} props.list
         * @param {string} props.list.label
         * @param {string} props.list.iconClass
         * @param {object} props.list.subOptions
         * @param {function} props.list.callback
         * @param {string} [props.list.property] prop that will be used to highlight modification button
         * @param change
         * @return {HTMLElement}
         */
        create({props, change}) {
            props.component = props.component || editor.getSelected();
            const selected = props.component,
                isUserPremium = PMW.getUserPremiumLevel() > 0,
                container = document.createElement('ul'),
                wrapper = document.createElement('div');

            container.className = props.type + ' mod-list-container list-two ' + props.class;
            wrapper.className = 'mod-list-wrapper';

            props.list.forEach((item) => {
                let li = document.createElement('li'),
                    div = document.createElement('div'),
                    icon = document.createElement('i'),
                    label = document.createElement('span'),
                    isPropertySet = item.property && selected.get(item.property);

                li.className = 'mod-list-item _cursor-pointer hover-transition-all';
                div.className = 'mod-list-item-div _full-height';
                div.title = item.label;
                icon.className = 'mod-list-item-icon icon ' + item.iconClass;
                label.className = 'mod-list-item-label body-xxs ' + (item.label ? '' : ' _hidden');
                label.innerHTML = item.label;

                if (isPropertySet) {
                    li.className += ' -selected';
                }

                if (item.action && item.action === window.PMW.emails.commands.REMOVE_BACKGROUND) {
                    let tagDiv = document.createElement('div');
                    tagDiv.className = 'tag _position-absolute';
                    tagDiv.innerHTML = renderTag(window.PMW.emails.NUM_REMOVE_BACKGROUND_CREDITS, isUserPremium);
                    li.appendChild(tagDiv);
                }

                if (item.subOptions) {
                    const subOptionsContainer = getModItemSubOptions(item, container);
                    wrapper.appendChild(subOptionsContainer)
                }

                div.appendChild(icon);
                div.appendChild(label);
                li.appendChild(div);
                container.appendChild(li);
                wrapper.prepend(container);

                div.addEventListener('click', async function () {
                    if (typeof item.callback !== 'function') {
                        return;
                    }

                    await item.callback(editor, selected, li, wrapper);
                    change({
                        li: li,
                        component: selected,
                        property: item.property,
                    });
                });
            });

            return wrapper;
        },
        emit({props}, {li, component, property}) {
            li.className = li.className.replace('-selected', '').trim();

            if (component.get(property)) {
                li.className += ' -selected';
            }
        },
        update({value, el}) {
        }
    });

    function getModItemSubOptions(listItem, modListContainer) {
        let subOptionsContainer = document.createElement('div');
        subOptionsContainer.className = 'mod-list-suboptions-container bg-neutral-1 spacing-p-3 radius-4 _hidden';

        const subOptionsHeader = getSubOptionsHeader(listItem, modListContainer, subOptionsContainer);
        const subOptions = getSubOptionsList(listItem);

        subOptionsContainer.appendChild(subOptionsHeader);
        subOptionsContainer.appendChild(subOptions);

        return subOptionsContainer;
    }

    function getSubOptionsHeader(listItem, modListContainer, subOptionsContainer) {
        let subOptionsHeader = document.createElement('div');
        subOptionsHeader.className = 'flex-h-row flex-content-between spacing-m-b-4';

        let subOptionsHeaderTitle = document.createElement('div');
        subOptionsHeaderTitle.className = 'flex-center';

        let subOptionsIcon = document.createElement('i');
        subOptionsIcon.className = 'pmw-icon size-icon-20 content-body spacing-m-r-3 ' + listItem.iconClass;

        let subOptionsHeaderLabel = document.createElement('label');
        subOptionsHeaderLabel.className = 'body-xs content-body';
        subOptionsHeaderLabel.innerHTML = listItem.label;

        let subOptionsHeaderCloseCTA = document.createElement('i');
        subOptionsHeaderCloseCTA.className = 'pmw-icon size-icon-20 -square -ghost-uncolored icon-close content-body';

        subOptionsHeaderCloseCTA.addEventListener('click', function () {
            subOptionsContainer.classList.add('_hidden');
            modListContainer.classList.remove('_hidden');
        });

        subOptionsHeaderTitle.appendChild(subOptionsIcon);
        subOptionsHeaderTitle.appendChild(subOptionsHeaderLabel);
        subOptionsHeader.appendChild(subOptionsHeaderTitle);
        subOptionsHeader.appendChild(subOptionsHeaderCloseCTA);

        return subOptionsHeader
    }

    function getSubOptionsList(listItem) {
        let subOptions = document.createElement('ul');

        listItem.subOptions.forEach((option) => {
            let subOption = document.createElement('li');
            subOption.className = 'flex-center flex-v-row mod-list-suboption spacing-p-4 radius-4 bg-neutral-0 border-s-dark _cursor-pointer hover-transition-all'

            let icon = document.createElement('i');
            icon.className = 'pmw-icon size-icon-24 content-body ' + option.icon

            let label = document.createElement('span');
            label.className = 'body-xs content-body mod-list-suboption-label'
            label.innerHTML = option.label;

            subOption.addEventListener('click', async function () {
                if (typeof option.cb !== 'function') {
                    return;
                }

                option.cb()
            });

            subOption.appendChild(icon);
            subOption.appendChild(label);
            subOptions.appendChild(subOption);
        })

        return subOptions
    }

    /**
     * Gets HTML tag new and credit count
     * @param {boolean} isUserPremium
     * @param {int} removeBackgroundCredits
     */
    function renderTag(removeBackgroundCredits, isUserPremium) {
        const hideRemainingBgRemovals = removeBackgroundCredits && (removeBackgroundCredits > -1),
            premiumTagDiv = `<i class="color-premium icon-crown pmw-icon -icon-only size-icon-20"></i>`,
            creditsDiv = hideRemainingBgRemovals ?
                `<div class="bg-removals-tag js-bg-credits body-xxs-bold radius-round content-body-white _fit-width flex-center bg-secondary-150" rel="tooltip" data-is-modern-tooltip = "1"
                 title= "${i18next.t('pmwjs_credits_cost_and_remaining_info', {creditsRemaining: removeBackgroundCredits, creditsCost: 1})}">
                    ${formatToNearestThousand(removeBackgroundCredits)}
                 </div>`
                : '';

        return isUserPremium ? creditsDiv : premiumTagDiv;
    }

    function formatToNearestThousand(credits) {
        if (credits > 999) {
            const temp = credits / 1000;
            return `${temp.toFixed(0)}k`;
        }

        return String(credits);
    }
}